document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ---- Collection page: fast-cycle product card images on hover ---- */
  document.querySelectorAll('[data-card-gallery]').forEach(function (gallery) {
    var images = gallery.querySelectorAll('.card-gallery__image');
    if (images.length < 2) return;

    var card = gallery.closest('.card-wrapper') || gallery;
    var index = 0;
    var intervalId = null;

    function advance() {
      images[index].classList.remove('is-active');
      index = (index + 1) % images.length;
      images[index].classList.add('is-active');
    }

    function start() {
      stop();
      intervalId = setInterval(advance, 800);
    }

    function stop() {
      clearInterval(intervalId);
      images[index].classList.remove('is-active');
      index = 0;
      images[0].classList.add('is-active');
    }

    card.addEventListener('mouseenter', start);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focusin', start);
    card.addEventListener('focusout', stop);
  });

  /* ---- Product page: auto-advance without the theme's setActiveMedia() ---- */
  document.querySelectorAll('media-gallery').forEach(function (galleryEl) {
    var viewer = galleryEl.querySelector('[id^="GalleryViewer-"]');
    var thumbWrapper = galleryEl.querySelector('[id^="GalleryThumbnails-"]');
    if (!viewer) return;
    if ((galleryEl.dataset.vendor || '').toLowerCase() === 'mattel') return;
    var items = Array.from(viewer.querySelectorAll('.product__media-item[data-media-id]'));
    if (items.length < 2) return;

    items.forEach(function (item) {
      item.classList.remove('scroll-trigger', 'animate--fade-in');
      var img = item.querySelector('img');
      if (img) img.loading = 'eager';
    });

    // Lock every slide's container to the same aspect ratio so the
    // gallery height doesn't resize (and shove the thumbnails around)
    // every time the active image changes.
    var firstContainer = items[0].querySelector('.product-media-container');
    var lockedRatio = firstContainer && firstContainer.style.getPropertyValue('--ratio');
    var lockedPreviewRatio = firstContainer && firstContainer.style.getPropertyValue('--preview-ratio');
    if (lockedRatio) {
      items.forEach(function (item) {
        var container = item.querySelector('.product-media-container');
        if (!container) return;
        container.style.setProperty('--ratio', lockedRatio);
        if (lockedPreviewRatio) container.style.setProperty('--preview-ratio', lockedPreviewRatio);
      });
    }

    // Matches the breakpoint Dawn's own media-gallery.js uses to decide
    // between the desktop stacked viewer and the mobile native-scroll slider.
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    // Pause auto-advance for a while after the user actually interacts
    // with the gallery (clicking a thumbnail/arrow, or swiping on mobile),
    // so it doesn't yank away the image they're trying to look at.
    var PAUSE_MS = 5000;
    var lastInteraction = 0;
    var isProgrammaticScroll = false;

    function markInteraction() {
      if (isProgrammaticScroll) return;
      lastInteraction = Date.now();
    }

    galleryEl.addEventListener('click', markInteraction);
    galleryEl.addEventListener('touchstart', markInteraction, { passive: true });

    var scrollContainer = viewer.querySelector('[id^="Slider-Gallery-"]') || viewer;
    // The scrollTo() call below (mobile auto-advance) fires its own native
    // 'scroll' event -- without the isProgrammaticScroll guard above, the
    // script would mistake its own movement for user interaction and
    // permanently pause itself after the very first mobile tick.
    scrollContainer.addEventListener('scroll', markInteraction, { passive: true });

    // Dawn's prev/next slider-buttons (and touch swipes) move the visible
    // slide via native scrolling, without ever touching .is-active on the
    // items themselves -- only a thumbnail click routes through Dawn's own
    // setActiveMedia(), which does set it. Left alone, .is-active goes
    // stale after using the arrows: the auto-advance timer would then
    // treat the last thumbnail-set slide as "current" and step from
    // there, e.g. skipping straight from slide 2 to slide 4 after
    // manually going back from 3 to 2 with the arrow button. Resync it
    // here using Dawn's own 'slideChanged' event, which fires on any
    // native scroll settle regardless of what caused it.
    viewer.addEventListener('slideChanged', function (event) {
      var currentElement = event.detail && event.detail.currentElement;
      if (!currentElement) return;
      items.forEach(function (item) { item.classList.remove('is-active'); });
      currentElement.classList.add('is-active');
    });

    setInterval(function () {
      if (Date.now() - lastInteraction < PAUSE_MS) return;

      // Re-read the current slide from the DOM on every tick instead of
      // trusting a locally-tracked counter. A user's thumbnail click is
      // handled entirely by Dawn's own media-gallery.js, which strips
      // .is-active from every item and adds it to the clicked one --
      // independently of this timer. A stale counter here would then
      // remove/add .is-active on the wrong elements, leaving two items
      // active at once (a visibly stacked duplicate image) until the
      // counter happened to cycle back into alignment.
      var index = items.findIndex(function (el) { return el.classList.contains('is-active'); });
      if (index === -1) index = 0;

      var current = items[index];
      var next = items[(index + 1) % items.length];

      current.classList.remove('is-active');
      next.classList.add('is-active');

      if (mobileQuery.matches) {
        // Dawn's mobile gallery is a native horizontally-scrolling slider --
        // every slide is already in the DOM side by side, and .is-active
        // toggling alone doesn't move anything visually there. Scroll it
        // into view manually, mirroring what Dawn's own setActiveMedia()
        // does on mobile when a thumbnail is clicked.
        isProgrammaticScroll = true;
        next.parentElement.scrollTo({ left: next.offsetLeft, behavior: 'smooth' });
        window.setTimeout(function () { isProgrammaticScroll = false; }, 600);
      }

      if (thumbWrapper) {
        var mediaId = next.dataset.mediaId;
        thumbWrapper.querySelectorAll('button[aria-current]').forEach(function (btn) {
          btn.removeAttribute('aria-current');
        });
        var thumbLi = thumbWrapper.querySelector('[data-target="' + mediaId + '"]');
        var thumbBtn = thumbLi && thumbLi.querySelector('button');
        if (thumbBtn) thumbBtn.setAttribute('aria-current', 'true');
      }
    }, 1500);
  });
});
